import {
  Avatar,
  Box,
  Divider,
  Grid,
  makeStyles,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { Label } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import CustomSelect from "../../../../../Components/CustomSelect";
import DataService from "../../../../../Service";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { utils, writeFile, write } from "xlsx";
import logoImage from "../../../../../Images/acuity-logo.png";
import clientLogoDemo from "../../../../../Images/demo_client_new_logo.png";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import { useDispatch, useSelector } from "react-redux";
import useDownloads from "../useDownloads";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: "0 auto",
  },
  customTextField: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: "0px",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
}));

function SearchFilter() {
  const classes = useStyles();
  const data = {
    filter: "",
    sort_by: "",
    business_unit_id: "",
    assignment_id: "",
    service_type: "",
    given_by_id: "",
    service_type_id: "",
  };

  const [userData, setUserData] = useState(data);
  // const [userData, setUserData] = useState({
  //     givenBy: "",
  //     sessionScenario: "",
  //     sortBy: "",
  //     businessunit: "",
  // });
  const dispatch = useDispatch();
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [orgValue, setOrgValue] = React.useState("");
  const [businessUnit, setBusinessUnit] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [givenby, setGivenby] = useState([]);
  const [assesment, setAssesmentStage] = useState([]);
  const [inputValue1, setInputValue1] = React.useState("");
  const [inputValue2, setInputValue2] = React.useState("");
  const [inputValue3, setInputValue3] = React.useState("");
  const [inputValue4, setInputValue4] = useState("");
  const sortByArray = [
    { id: "External", name: "External", value: "External" },
    { id: "Internal", name: "Internal", value: "Internal" },
  ];

  const onChangeItem = (selectedItemValue) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  useEffect(() => {
    const params = {
      // organisation_id: value.id,
    };
    DataService.getDirectData(
      `/acuity_feedbacks/employee_feedback_listing_dropdowns`,
      params
    ).then((res) => {
      if (res) {
        setBusinessUnit(res.business_unit);
        setServiceType(res.service_type);
        setGivenby(res["given_by"]);
        setAssesmentStage(res.assessment_stage);
        // let CoachinRates = res.employee_collate_objective;
        // setCAFList(CoachinRates);

        // setLoading(false);
      }
    });
  }, []);
  const [feedbackList, setFeedbackList] = useState([]);
  console.log("new add", serviceType);

  const feedbackApi = () => {
    const params = {
      organisation_id: value.id,
      sort_by: userData.sort_by,
      business_unit_id: userData.business_unit_id,
      service_type_id: userData.service_type_id,
      service_type: userData.service_type,
      assignment_id: userData.assignment_id,
      given_by_id: userData.given_by_id,
      // page: page + 1 || 1,
      // count_per_page: pageSize || 20,
    };
    DataService.getDirectData(
      `/acuity_feedbacks/employee_acuity_feedback`,
      params
    ).then((res) => {
      // setTotalCount(res["total_count"]);
      let CoachinRates = res.acuity_feedbacks;
      setFeedbackList(CoachinRates);

      // setLoading(false);
    });
  };
  useEffect(() => {
    // setLoading(true);
    feedbackApi();
    // setRefresh(!refresh)
  }, [userData]);

  const getData = () => {
    const params = {
      organisation_id: value.id,
      sort_by: userData.sort_by,
      business_unit_id: userData.business_unit_id,
      service_type_id: userData.service_type_id,
      service_type: userData.service_type,
      assignment_id: userData.assignment_id,
      given_by_id: userData.given_by_id,
      // page: page + 1 || 1,
      // count_per_page: pageSize || 20,
    };
    return DataService.getDirectData(
      `/acuity_feedbacks/employee_acuity_feedback`,
      params
    );
  };
  const globaluserData = useSelector((state) => state.commonReducer);
  const fileName = globaluserData?.organisation_name + "_Feedback";
  // const fileName = sessionStorage.getItem("organisation_name") + "_Feedback";
  const columns = [
    { field: "feedback", title: "Feedback" },
    // { field: "session_scenario", title: "Session scenario" },
    { field: "employee_name", title: "Given by" },
  ];
  const organisation_id = sessionStorage.getItem("organisation_id");
  const role = sessionStorage.getItem("role");
  const { downloading, downloadingOption, exportPDF, exportCsv, exportXLSX } =
    useDownloads({
      columns,
      getData,
      listKey: "acuity_feedbacks",
      userData: {
        organisation: value.id || organisation_id,
      },
      role,
      fileName,
    });

  return (
    <div className={classes.wrapper}>
      <React.Fragment>
        <Typography
          variant="subtitle1"
          color="secondary"
          style={{ marginTop: 15 }}
        >
          <Box mb={1} fontWeight="fontWeightBold">
            {/* Organisation name - {organisationName} */}
          </Box>
        </Typography>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Grid container direction="row" spacing={1}>
              <Grid item>
                <Typography variant="subtitle1">
                  <Box mb={1} color={"#EF7000"}>
                    Service
                  </Box>
                </Typography>
                {/* <CustomSelect
                    id="service_type"
                    labelText="Select service type"
                    displayEmpty
                    variant="outlined"
                    // itemArr={sortByArray}
                    itemArr={sortByArray.map((el) => el.value)}
                    parentcall={onChangeItem}
                  /> */}
                <Autocomplete
                  // value={value}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      newValue = "";
                    }
                    // setValue(newValue);
                    setUserData({
                      ...userData,
                      service_type: newValue.id,
                    });
                  }}
                  inputValue={inputValue2}
                  onInputChange={(event, newInputValue) => {
                    setInputValue2(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={sortByArray}
                  getOptionLabel={(option) => option.value}
                  style={{ width: 260 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      classes={{ root: classes.customTextField }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          fontSize: "16px",
                          padding: "2px !important",
                        },
                      }}
                      placeholder="Select service"
                      InputLabelProps={{
                        style: { fontSize: "16px", fontFamily: "Open Sans" },
                      }}
                      autoFocus
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1">
                  <Box mb={1} color={"#EF7000"}>
                    Service Type
                  </Box>
                </Typography>
                <Autocomplete
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      newValue = "";
                    }
                    setUserData({
                      ...userData,
                      service_type_id: newValue.id,
                    });
                  }}
                  inputValue={inputValue4}
                  onInputChange={(event, newInputValue) => {
                    setInputValue4(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={serviceType}
                  style={{ width: 260 }}
                  getOptionLabel={(option) => option.value}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      classes={{ root: classes.customTextField }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          fontSize: "16px",
                          padding: "2px !important",
                        },
                      }}
                      placeholder="Select service type"
                      InputLabelProps={{
                        style: { fontSize: "16px", fontFamily: "Open Sans" },
                      }}
                      autoFocus
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1">
                  <Box mb={1} color={"#EF7000"}>
                    Sort by
                  </Box>
                </Typography>

                <CustomSelect
                  id="sort_by"
                  labelText="Select sort by"
                  displayEmpty
                  style={{ width: "260px" }}
                  variant="outlined"
                  itemArr={["Newest", "Oldest"]}
                  parentcall={onChangeItem}

                  // defaultValue={userData.sortBy}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1">
                  <Box mb={1} color={"#EF7000"}>
                    Business unit
                  </Box>
                </Typography>

                {/* <Select
                    id="business_unit_id"
                    name="business_unit_id"             
                    // onChange={onChangeItem}
                    onChange={(obj) => {
                      obj.target.value && onChangeItem(`business_unit_id`, obj.target.value)
                  }}
                    variant="outlined"
                    hideLable
                    style={{ width: "100%" }}
                  >
                    {businessUnit?.map((data) => {
                      return (
                        <MenuItem name={data?.id} value={data?.id}>
                          <Typography variant="h2">{data?.value}</Typography>
                        </MenuItem>
                      );
                    })}
                  </Select> */}
                <Autocomplete
                  // value={value}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      newValue = "";
                    }
                    // setValue(newValue);
                    setUserData({
                      ...userData,
                      business_unit_id: newValue.id,
                    });
                  }}
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={businessUnit}
                  style={{ width: 260 }}
                  getOptionLabel={(option) => option.value}
                  // style={{ width: 260 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      classes={{ root: classes.customTextField }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          fontSize: "16px",
                          padding: "2px !important",
                        },
                      }}
                      placeholder="Select business unit"
                      InputLabelProps={{
                        style: { fontSize: "16px", fontFamily: "Open Sans" },
                      }}
                      autoFocus
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1">
                  <Box mb={1} color={"#EF7000"}>
                    Given by
                  </Box>
                </Typography>

                <Autocomplete
                  // value={value}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      newValue = "";
                    }
                    setUserData({
                      ...userData,
                      given_by_id: newValue.id,
                    });
                  }}
                  inputValue={inputValue1}
                  onInputChange={(event, newInputValue) => {
                    setInputValue1(newInputValue);
                  }}
                  ListboxProps={{ style: { maxHeight: 150 } }}
                  id="controllable-states-demo"
                  options={givenby}
                  getOptionLabel={(option) => option.value}
                  style={{ width: 260 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      classes={{ root: classes.customTextField }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          fontSize: "16px",
                          padding: "2px !important",
                        },
                      }}
                      placeholder="Select given by"
                      InputLabelProps={{
                        style: { fontSize: "16px", fontFamily: "Open Sans" },
                      }}
                      autoFocus
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item>
                <Typography variant="subtitle1">
                  <Box mb={1} color={"#EF7000"}>
                    Assignment stage
                  </Box>
                </Typography>
                <Autocomplete
                  // value={value}
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      newValue = "";
                    }
                    // setValue(newValue);
                    setUserData({
                      ...userData,
                      assignment_id: newValue.id,
                    });
                  }}
                  inputValue={inputValue3}
                  onInputChange={(event, newInputValue) => {
                    setInputValue3(newInputValue);
                  }}
                  id="controllable-states-demo"
                  options={assesment}
                  getOptionLabel={(option) => option.value}
                  style={{ width: 260 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      classes={{ root: classes.customTextField }}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          fontSize: "16px",
                          padding: "2px !important",
                        },
                      }}
                      placeholder="Select assignment stage"
                      InputLabelProps={{
                        style: { fontSize: "16px", fontFamily: "Open Sans" },
                      }}
                      autoFocus
                      variant="outlined"
                    />
                  )}
                />
              </Grid>

              <Grid
                item
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  height: "100%",
                  alignSelf: "flex-end",
                  width: "280px",
                }}
              >
                <Button
                  color="primary"
                  disabled={!feedbackList?.length}
                  style={{
                    textTransform: "inherit",
                    float: "right",
                    marginTop: "18px",
                    width: "170px",
                  }}
                  variant="contained"
                  onClick={exportXLSX}
                >
                  {downloading && downloadingOption === "xlsx" ? (
                    <CircularProgress
                      size={22}
                      style={{ marginRight: "5px", color: "white" }}
                    />
                  ) : (
                    <SaveAltIcon style={{ marginRight: "5px" }} />
                  )}
                  .xlsx
                </Button>

                <Button
                  color="primary"
                  disabled={!feedbackList?.length}
                  style={{
                    textTransform: "inherit",
                    float: "right",
                    marginTop: "18px",
                    width: "170px",
                  }}
                  variant="contained"
                  onClick={exportCsv}
                >
                  {downloading && downloadingOption === "csv" ? (
                    <CircularProgress
                      size={22}
                      style={{ marginRight: "5px", color: "white" }}
                    />
                  ) : (
                    <SaveAltIcon style={{ marginRight: "5px" }} />
                  )}{" "}
                  .csv
                </Button>

                <Button
                  color="primary"
                  disabled={!feedbackList?.length}
                  style={{
                    textTransform: "inherit",
                    float: "right",
                    marginTop: "18px",
                    width: "170px",
                  }}
                  variant="contained"
                  onClick={exportPDF}
                >
                  {downloading && downloadingOption === "pdf" ? (
                    <CircularProgress
                      size={22}
                      style={{ marginRight: "5px", color: "white" }}
                    />
                  ) : (
                    <SaveAltIcon style={{ marginRight: "5px" }} />
                  )}{" "}
                  .pdf
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </React.Fragment>
      <Box mt={4}>
        {feedbackList.map((option) => {
          return (
            <>
              <Grid
                container
                direction="row"
                spacing={2}
                style={{ marginTop: 20 }}
              >
                <Grid item xs={1}>
                  <Box>
                    <Avatar
                      alt="Remy Sharp"
                      src={option.employee_image}
                      className={classes.small}
                    />
                  </Box>
                </Grid>
                <Grid item xs={11}>
                  <Typography variant="h2">
                    <Box fontWeight="fontWeightBold" mb={2}>
                      {option.employee_name}
                    </Box>
                  </Typography>
                  <Typography variant="h2">
                    <Box mb={2}>{option.feedback}</Box>
                  </Typography>
                </Grid>
              </Grid>
              <Divider />
            </>
          );
        })}
      </Box>
    </div>
  );
}

export default SearchFilter;
